<template>
  <div class="row">
    <!--FILTER-->
    <ed-modal
      :title="'FILTRAR RESULTADO' + ' (' + filterBadge + ')'"
      :modal="showFilter"
      :onSave="handleFilter"
      :onClear="handleClear"
      :isModal="false"
      width="80%"
      saveName="Filtrar"
      saveIcon="fa fa-filter"
    >
      <div slot="modal-content">
        <slot name="table-filter-content" />
      </div>
    </ed-modal>

    <!--NOVO REGISTRO-->
    <div
      class="col-md-12 mb-1"
      v-if="onRegister || !disableInputSearch || !disableInputButtons"
    >
      <div class="row d-flex align-items-baseline">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <div class="table-button d-flex flex-row">
            <ed-button
              v-if="onRegister"
              class="mb-1 mr-1"
              type="primary"
              :icon="registerIcon"
              :loading="loadingRegister"
              :value="registerName"
              @click="onRegister"
            />
            <slot name="table-button"></slot>
          </div>
        </div>

        <div
          :class="
            onRegister
              ? 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'
              : 'col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12'
          "
          v-if="!disableInputSearch"
        >
          <b-input-group class="mt-3">
            <b-form-input
              placeholder="Digite aqui sua pesquisa e pressione ENTER..."
              @keyup.enter="handleSearch"
              v-model="formData.search"
            >
            </b-form-input>

            <b-input-group-append>
              <b-button
                variant="outline-secondary"
                @click="handleSearch"
                title="Clique para relizar sua busca..."
              >
                <i class="fa fa-search" />
                <span class="d-none d-sm-inline d-xl-inline">Buscar</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="handleFilter"
                v-if="onFilter"
                :title="
                  filterBadge + ' filtro(s) ativados, clique para saber mais...'
                "
              >
                <i
                  :class="
                    'fa fa-filter' +
                    (filterBadge > 0 ? ' faa-flash animated' : '')
                  "
                />
                <span class="d-none d-sm-inline d-xl-inline">Filtrar</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </div>

    <!--MOSTRAR LISTA-->
    <div class="col-md-12">
      <!--POPOVER CHECK ALL-->
      <el-popover
        ref="deleteAll"
        placement="top"
        trigger="manual"
        v-model="showPopoverCheckAll"
      >
        <div style="row d-flex align-items-center">
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3"
          >
            <b>O que deseja fazer com os registro(s) selecionado(s)?</b>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-1"
          >
            <ed-button
              icon="fa fa-window-close-o"
              type="info"
              size="mini"
              title="Calcelar"
              value="Cancelar"
              @click="handleSearch"
            />

            <ed-button
              v-if="onDelete && checkItem.length > 0"
              icon="fa fa-trash"
              type="danger"
              size="mini"
              :title="onDeleteName"
              :value="onDeleteName"
              @click="handleDelete"
            />

            <ed-button
              v-if="onEditAll && checkItem.length > 0"
              :icon="editAllIcon"
              type="warning"
              size="mini"
              :title="editAllTitle"
              @click="handleEditAll"
              :loading="loadingEditAll"
              :value="editAllName"
            />
          </div>
        </div>
      </el-popover>
    </div>

    <div
      class="col-md-12"
      style="margin-top: 20px; margin-bottom: 10px"
      v-if="onSearch"
    >
      <el-select
        v-model="formData.ppage"
        @change="handleSearch"
        :style="
          'width: ' + (this.device == 'xs' ? '100%' : '220px') + ' !important'
        "
      >
        <el-option
          v-for="page in lstPages"
          :key="page"
          :label="'Exibir ' + page + ' itens por página'"
          :value="page"
        >
        </el-option>
      </el-select>
    </div>

    <div class="col-md-12" v-loading="disableTableContent && loadingTable">
      <slot name="table-export" v-if="tableData.length > 0"></slot>
      <slot name="table-content"></slot>
      <b-table
        v-if="!disableTableContent"
        class="table-v2"
        id="table-v2"
        ref="selectableTable"
        striped
        hover
        bordered
        small
        show-empty
        responsive
        head-variant="light"
        :empty-text="
          response && response.status && response.status != 200
            ? response.status + (response.msg ? ' - ' + response.msg : '')
            : emptyTable
        "
        :busy="loadingTable"
        :items="items"
        :fields="fields"
        :stacked="this.device == 'xs'"
        :sort-by.sync="formData.sortBy"
        :sort-desc.sync="formData.sortDesc"
        :foot-clone="tableFooter.length > 0"
      >
        <!--FORMATAR CABEÇALHO-->
        <template v-slot:head()="data">
          {{ data.label }}
          <i
            v-if="
              formData.sortBy == data.field.key && formData.sortDesc == true
            "
            class="fa fa-sort-alpha-desc"
          />
          <i
            v-if="
              formData.sortBy == data.field.key && formData.sortDesc == false
            "
            class="fa fa-sort-alpha-asc"
          />
          <el-tooltip
            v-if="data.field.info"
            class="item"
            effect="dark"
            :content="data.field.info"
            placement="top"
          >
            <a href="#" style="color: #fff">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </a>
          </el-tooltip>
        </template>

        <!--FOOTER-->
        <template v-slot:foot()="data">
          <span v-if="data.field && data.field.value != undefined">
            {{ data.field.value }}
          </span>
        </template>

        <!--LOADING TABLE-->
        <template v-slot:table-busy>
          <div class="text-center my-2" style="color: var(--primary)">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <!--STYLE TABLE-->
        <template v-slot:table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
          />
        </template>

        <!--SELECTED TODOS-->
        <template v-slot:head(selected)="scope">
          <div class="text-center" v-popover:deleteAll>
            <el-checkbox v-model="checkAll" @change="handleSelectAll" />
          </div>
        </template>

        <!--SELECTED ITEM-->
        <template v-slot:cell(selected)="data">
          <div class="text-center">
            <el-checkbox
              :label="data.item._data.id"
              v-model="checkItem"
              @change="handleSelectItem"
            />
          </div>
        </template>

        <!--TIPO STATUS-->
        <template v-slot:cell(tipo_status)="data">
          <div
            v-if="data.item._data.tipo_status"
            :style="'color:' + data.item._data.tipo_status.cor"
          >
            <i
              v-if="data.item._data.tipo_status.icon"
              :class="data.item._data.tipo_status.icon"
            />
            <span v-html="data.value"></span>
          </div>

          <div v-else>
            <span v-html="data.value"></span>
          </div>
        </template>


        <!--FORMATAR COLUNAS-->
        <template v-slot:cell()="data">
          <!-- TIPO ASO -->
          <div
            v-if="
              data.field && data.field.show_tipo_aso && data.item._data.tipo_aso
            "
          >
            <a
              v-if="
                (data.field.show_consulta_link ||
                  data.field.show_link_consulta) &&
                data.item._data.id_con
              "
              :href="getUrlConsulta(data.item._data)"
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                :style="(data.item.options && data.item.options.style ? data.item.options.style : '')"
              >
                <i class="fa fa-external-link" aria-hidden="true"></i>
                CÓD: <span v-html="data.value"></span><br />
              </span>
              <span :style="'font-size: 7pt; color: #666;'+(data.item.options && data.item.options.style ? data.item.options.style : '')">
                {{ data.item._data.tipo_aso.descricao }}
              </span>
            </a>

            <span v-else>
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
              >
                {{ data.value }}<br />
              </span>
              <span style="font-size: 7pt; color: #666">
                {{ data.item._data.tipo_aso.descricao }} {{(data.item._data.periodicidade ? data.item._data.periodicidade+' MESES' : '')}}
              </span>
            </span>
          </div>

            <a
              v-if="
                (data.field.show_consulta_link ||
                  data.field.show_link_consulta) &&
                data.item._data.id_con && data.item._data.consulta
              "

              :href="getUrlConsulta(data.item._data)"
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                :style="(data.item.options && data.item.options.style ? data.item.options.style : '')"
              >
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span v-html="data.value"></span><br />

                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span >{{$utilidade.toDate(data.item._data.consulta.dt_cad,true)}}</span><br />
              </span>

            </a>

          <!-- LINK EMPRESA -->
          <div
            v-else-if="data.field && data.field.show_empresa_link"
          >
            <a
              :href="getUrlEmpresa(data.item._data)"
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                :style="
                  data.item.options && data.item.options.style
                    ? ';' + data.item.options.style
                    : ''
                "
              >
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span v-html="data.value"/><br />
              </span>
              <span
                v-if="data.field.show_fdt && data.item._data.fdt && data.item._data.fdt.pcmso"
                :style="
                  'font-size:7pt;color:#666' +
                  (data.item.options && data.item.options.style
                    ? ';' + data.item.options.style
                    : '')
                "
              >
                {{ data.item._data.fdt.pcmso }} ({{
                  data.item._data.fdt.descricao
                }})
              </span>
            </a>
          </div>

          <!-- LINK REVISAO -->
          <div
            v-else-if="data.field && data.field.show_revisao_link && data.item._data.revisao_tipo"
          >
            <a
              :href="
                env.url_cs +
                '/app/'+(data.item._data.revisao_tipo)+'.php?emp=' +
                (data.item._data.empresa ? data.item._data.empresa.id : data.item._data.empresa_id)+
                '&pcmso='+(data.item._data.fdt ? data.item._data.fdt.id : data.item._data.fdt_id)+
                '&rev='+(data.item._data.revisao ? data.item._data.revisao.id : data.item._data.revisao_id)
              "
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                :style="
                  data.item.options && data.item.options.style
                    ? ';' + data.item.options.style
                    : ''
                "
              >
                <i class="fa fa-external-link" aria-hidden="true"></i>
                <span v-html="data.value"/><br />
              </span>
            </a>
          </div>

          <!-- FUNÇÃO -->
          <div
            v-else-if="
              data.field && data.field.show_funcao && data.item._data.funcao
            "
          >
            <a
              v-if="data.field.show_funcionario_link"
              :href="getUrlFuncionario(data.item._data)"
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                :style="(data.item.options && data.item.options.style ? data.item.options.style : '')"  
                <i class="fa fa-external-link" aria-hidden="true"/>
                {{ data.value }}<br />
              </span>
              <span style="font-size: 7pt; color: #666">
                <span
                  :class="data.item._data.deleted_at ? 'deleted' : ''"
                  :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                  :style="(data.item.options && data.item.options.style ? data.item.options.style : '')"
                >
                  {{ data.item._data.funcao.nome }}
                </span>
              </span>
            </a>

            <span v-else>
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
              >
                {{ data.value }}<br />
              </span>
              <span style="font-size: 7pt; color: #666">
                <span
                  :class="data.item._data.deleted_at ? 'deleted' : ''"
                  :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
                >
                  {{ data.item._data.funcao.nome }}
                </span>
              </span>
            </span>
          </div>

          <!-- FINANCEIRO -->
          <div v-else-if="data.field && data.field.show_financeiro_link">
            <a
              :href="
                env.url_cs +
                '/app/financeiro_rel.php?cod_tp=0&cod_n=' +
                data.value
              "
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
              >
                {{ data.value }}
              </span>
            </a>
          </div>

          <!-- LOTE ESOCIAL -->
          <div
            v-else-if="
              data.field && data.field.show_lote_link && data.item._data
            "
          >
            <a
              :href="getUrlLote(data.item._data)"
              target="_blank"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
              >
                <span v-html="data.value"></span>
              </span>
            </a>
          </div>

          <!-- USUARIO UPDATED -->
          <div
            v-else-if="
              data.field && data.field.show_user && data.item._data.usuario
            "
            :style="
              data.item.options && data.item.options.style
                ? data.item.options.style
                : ''
            "
          >
            {{ data.value }}<br />
            <span
              :style="
                'font-size:7pt' +
                (data.item.options && data.item.options.style
                  ? data.item.options.style
                  : '')
              "
            >
              {{ data.item._data.usuario.usuario }}
            </span>
          </div>

          <!-- ARQUIVO -->
          <div v-else-if="data.field && data.field.show_arquivo">
            <Download
              :arquivo="data.value"
              v-if="data.value && data.value.id"
            />
            <span v-else>---</span>
          </div>

          <!-- INPUT MONEY -->
          <div v-else-if="data.field && data.field.show_input">
            <el-input
              v-if="data.field.edit == 'money'"
              v-model="data.item._data[data.field.key]"
              v-mask="'money'"
              type="text"
            />
            <el-input
              v-else-if="data.field.edit == 'number'"
              v-model="data.item._data[data.field.key]"
              type="number"
            />
          </div>

          <!-- POINT -->
          <div v-else-if="data.field && data.field.show_point">
            {{ data.value }}
            <span
              style="font-size: 7pt; color: #666"
              v-if="
                data.item._data.log_acesso.usuario &&
                data.item._data.log_acesso.usuario.point
              "
            >
              <br />{{ data.item._data.log_acesso.usuario.point.nome }}
            </span>
          </div>

          <!-- STATUS -->
          <div
            v-else-if="
              data.field &&
              data.field.show_status &&
              data.item._data.tipo_status
            "
          >
            <span
              :style="'color:' + data.item._data.tipo_status.cor"
              :title="data.value"
            >
              <span
                :class="data.item._data.deleted_at ? 'deleted' : ''"
                :title="
                  data.item._data.deleted_at ? 'Registro excluído' : data.value
                "
              >
                <i
                  v-if="data.item._data.tipo_status.icon"
                  :class="data.item._data.tipo_status.icon"
                />
                {{ data.item._data.tipo_status.descricao }}
              </span>
            </span>
          </div>

          <!-- CONSULTA REAPROVEITAMENTO -->
          <div
            v-else-if="
              data.field && data.field.show_rea && data.item._data.id_con_rea
            "
          >
            <span
              :class="data.item._data.deleted_at ? 'deleted' : ''"
              :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
            >
              {{ data.value }}<br />
            </span>
            <span
              style="font-size: 9pt"
              class="tp-exame-rea"
              title="Esse exame é um reaproveitamento. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
            >
              Exame <b>reaproveitado</b> da consulta
              <label style="color: red">{{ data.item._data.id_con_rea }}</label>
              <span v-if="data.item._data.con_rea_dt">
                em {{ toDate(data.item._data.con_rea_dt, true) }}
              </span>
            </span>
          </div>

          <div
            v-else-if="
              data.field && data.field.show_dem && data.item._data.id_con_dem
            "
          >
            <span
              :class="data.item._data.deleted_at ? 'deleted' : ''"
              :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
            >
              {{ data.value }}<br />
            </span>
            <span
              style="font-size: 9pt"
              class="tp-exame-dem"
              title="Esse exame é um demonstrativo. Isso quer dizer que não é necessário refaze-lo porque já foi realizado em outra ocasião e ainda está válido."
            >
              Exame <b>demonstrativo</b> na consulta
              <label style="color: red">{{ data.item._data.id_con_dem }}</label>
              <span v-if="data.item._data.con_dem_dt">
                em {{ toDate(data.item._data.con_dem_dt, true) }}
              </span>
            </span>
          </div>

          <div
            v-else-if="
              data.field && data.field.show_alt && data.item._data.alt == '1'
            "
          >
            <span
              title="Esse exame teve resultado alterado e deverá ser refeito no próximo periódico."
              :class="data.item._data.deleted_at ? 'deleted' : ''"
              style="color: #c64747"
            >
              <i class="fa fa-info-circle" aria-hidden="true" />
              {{ data.value }}
            </span>
          </div>

          <div
            v-else-if="
              data.field && data.field.show_parceiro && data.item._data.parceiro
            "
          >
            <span
              :class="data.item._data.deleted_at ? 'deleted' : ''"
              :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
            >
              {{ data.value }}<br />
            </span>
            <span
              style="font-size: 9pt; color: #c4c4c4"
              title="Parceiro que o exame será efetuado"
            >
              {{ data.item._data.parceiro.nome }}
            </span>
          </div>

          <!--FOFMAT JSON CONTENT-->
          <div v-else-if="data.field && data.field.show_json">
            <el-popover placement="top" trigger="click">
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <b>Detalhes</b>
                </div>

                <div
                  class="col-md-12"
                  v-for="(value, field, i) in data.value"
                  v-bind:key="i"
                >
                  <b>{{ field }}: </b>

                  <span v-if="field == 'exame' && value && value.nome">
                    {{ value.nome }}
                  </span>

                  <span v-else-if="field == 'parceiro' && value && value.nome">
                    {{ value.nome }}
                  </span>

                  <span
                    v-else-if="field == 'created_at' || field == 'updated_at'"
                  >
                    {{ toDate(value) }}
                  </span>

                  <span v-else-if="field == 'bl_his' || field == 'bl_his'">
                    <span v-html="base64Decode(value)" />
                  </span>

                  <span v-else>
                    {{ value }}
                  </span>
                </div>
              </div>

              <span slot="reference">
                <b-link>
                  <i class="fa fa-info-circle"></i>
                  Ver mais...
                </b-link>
              </span>
            </el-popover>
          </div>

          <!-- HTML -->
          <div v-else-if="data.field && data.field.show_html">
            <span v-html="data.value" />
          </div>

          <!--COLLAPSE-->
          <div v-else-if="data.field && data.field.show_colapse">
            <span v-if="!data.value">---</span>
            <el-collapse
              v-else
              title="Clique para mostrar mais informações"
              v-model="data.item._data[data.field.key].collapse"
            >
              <el-collapse-item
                :name="data.item._data.id.toString() + data.field.key"
              >
                <template slot="title">
                  <i
                    class="fa fa-minus-circle fa-1x"
                    style="color: #28a745"
                    v-if="
                      data.item._data[data.field.key].collapse &&
                      data.item._data[data.field.key].collapse[0]
                    "
                  />
                  <i
                    class="fa fa-plus-circle fa-1x"
                    style="color: #28a745"
                    v-else
                  />
                </template>
                <span v-html="data.value" style="font-size: 7pt" />
              </el-collapse-item>
            </el-collapse>
          </div>

          <div
            v-else
            :style="
              data.item.options && data.item.options.style
                ? data.item.options.style
                : ''
            "
            :title="
              data.item.options && data.item.options.title
                ? data.item.options.title
                : null
            "
          >
            <span
              :class="data.item._data.deleted_at ? 'deleted' : ''"
              :title="data.item._data.deleted_at ? 'Registro excluído' : ''"
            >
              <span
                v-if="
                  data.field.limit &&
                  data.field.limit < toString(data.value).length
                "
              >
                <el-popover placement="top" trigger="click">
                  <div class="row">
                    <div class="col-md-12 p-5">
                      {{ data.value }}
                    </div>
                  </div>

                  <span slot="reference">
                    <b-link>
                      <i class="fa fa-info-circle"></i>
                      Ver mais...
                    </b-link>
                  </span>
                </el-popover>
              </span>

              <span v-else>
                <!--EDIT ALL-->
                <span
                  v-if="
                    data.item &&
                    data.item._data &&
                    ((onEditAll &&
                      checkItem.indexOf(data.item._data.id) != -1) ||
                      editableRows)
                  "
                >
                  <!--MONEY-->
                  <el-input
                    v-if="data.field.edit == 'money'"
                    v-model="data.item._data[data.field.key]"
                    v-mask="'money'"
                    type="text"
                  />

                  <!--TEXT-->
                  <el-input
                    v-else-if="data.field.edit == 'text'"
                    v-model="data.item._data[data.field.key]"
                    type="text"
                  />

                  <!--CUSTOM SELECT-->
                  <el-select
                    v-else-if="
                      data.field.edit == 'select-custom' &&
                      config.click &&
                      config.click[data.field.key] &&
                      config.list &&
                      config.list[data.field.key]
                    "
                    v-model="data.item._data[data.field.key]"
                    :loading="config.loading[data.field.key]"
                    :placeholder="'Pesquisar...'"
                    filterable
                    remote
                    :remote-method="config.click[data.field.key]"
                    value-key="id"
                  >
                    <el-option
                      v-for="(val, j) in config.list[data.field.key]"
                      :key="j"
                      :label="val.nome"
                      :value="val.id"
                    />
                  </el-select>

                  <span v-else>
                    {{ data.value }}
                  </span>
                </span>

                <span v-else>
                  <span v-html="data.value" />

                  <span
                    v-if="
                      data.field && data.field.show_cnpj && data.item._data.cnpj
                    "
                    title="CNPJ"
                    :style="
                      'color:#666' +
                      (data.item.options && data.item.options.style
                        ? ';' + data.item.options.style
                        : '')
                    "
                  >
                    <br />
                    <i class="fa fa-credit-card-alt" aria-hidden="true"></i>
                    {{ data.item._data.cnpj }}
                  </span>

                  <span
                    v-if="
                      data.field && data.field.show_cpf && data.item._data.cpf
                    "
                    title="CPF"
                    :style="
                      'color:#666' +
                      (data.item.options && data.item.options.style
                        ? ';' + data.item.options.style
                        : '')
                    "
                  >
                    <br />
                    <i class="fa fa-address-card" aria-hidden="true"></i>
                    {{ data.item._data.cpf }}
                  </span>

                  <span
                    v-if="
                      data.field &&
                      data.field.show_telefone &&
                      onlyNumber(data.item._data.telefone)
                    "
                    title="Telefone"
                    :style="
                      'color:#666' +
                      (data.item.options && data.item.options.style
                        ? ';' + data.item.options.style
                        : '')
                    "
                  >
                    <br />
                    <i class="fa fa-phone-square" aria-hidden="true"></i>
                    {{ data.item._data.telefone }}
                  </span>
                </span>
              </span>
            </span>
          </div>
        </template>

        <!--BUTTONS-->
        <template v-slot:cell(buttons)="data">
          <div class="text-center tbutton">

            <!-- Option -->
            <!-- <el-switch
              title="Seguir Frente de Trabalho"
            >
            </el-switch> -->

            <ed-button
              style="margin: 2px"
              v-if="
                onEdit &&
                (!data.item.options ||
                  (data.item.options && !data.item.options.disable_edit))
              "
              icon="fa fa-pencil-square-o"
              type="primary"
              size="mini"
              title="Editar Registro"
              @click="handleEdit(data.item._data)"
            />

            <ed-button
              style="margin: 2px"
              v-for="(button, i) in data.value"
              v-bind:key="i"
              :icon="button.icon"
              :type="button.color"
              size="mini"
              :title="button.title"
              :style="button.style"
              @click="button.click(data.item._data)"
            />
            <ed-button
              style="margin: 2px"
              v-if="
                onDelete &&
                (!data.item.options ||
                  (data.item.options && !data.item.options.disable_delete))
              "
              icon="fa fa-trash"
              type="danger"
              size="mini"
              :title="onDeleteName"
              @click="handleDelete(data.item._data)"
            />
          </div>
        </template>
      </b-table>

      <div
        v-if="pagination && pagination.total && pagination.total > 0"
        class="text-center"
      >
        <ed-paginate :pagination="pagination" :navigation="handleNavigate" />
      </div>
    </div>
  </div>
</template>

<script>
import Rest from "common/rest";
import Fct from "common/fct";
import Download from "common/download";
import EdModal from "common/modal";
import EdButton from "common/button";
import EdAlert from "common/alert";
import EdError from "common/error";
import EdPaginate from "common/paginate";

export default {
  name: "table",
  components: { EdModal, EdButton, EdAlert, EdError, EdPaginate, Download },
  mixins: [Rest, Fct],
  props: {
    onEdit: {
      type: Function,
      default: null,
    },

    onEditAll: {
      type: Function,
      default: null,
    },
    onClear:{
      type: Function,
      default: null,
    },

    onDelete: {
      type: Function,
      default: null,
    },

    onRegister: {
      type: Function,
      default: null,
    },

    onSearch: {
      type: Function,
      default: null,
    },

    onFilter: {
      type: Function,
      default: null,
    },

    inputSearch: {
      type: String,
      default: null,
    },

    inputFilter: {
      type: Object,
      default: null,
    },

    onDeleteName: {
      type: String,
      default: "Deletrar Registro",
    },

    registerName: {
      type: String,
      default: "Novo Registro",
    },

    registerIcon: {
      type: String,
      default: "fa fa-plus-circle",
    },

    editAllIcon: {
      type: String,
      default: "fa fa-pencil-square-o",
    },

    editAllName: {
      type: String,
      default: "Editar Registro(s)",
    },

    editAllTitle: {
      type: String,
      default: "Editar Registro(s)",
    },

    emptyTable: {
      type: String,
      default: "Nenhum resultado encontrado",
    },

    tableHead: {
      type: Array,
      default() {
        return [];
      },
    },

    tableFooter: {
      type: Array,
      default() {
        return [];
      },
    },

    tableData: {
      type: Array,
      default() {
        return [];
      },
    },

    disableInputSearch: {
      type: Boolean,
      default: false,
    },

    disableInputButtons: {
      type: Boolean,
      default: true,
    },

    disableCheckAll: {
      type: Boolean,
      default: false,
    },

    disableTableContent: {
      type: Boolean,
      default: false,
    },

    editableRows: {
      type: Boolean,
      default: false,
    },

    disabledConfigCell: {
      type: Boolean,
      default: false,
    },

    pagination: {
      type: Object,
      default() {
        return {};
      },
    },

    config: {
      type: Object,
      default() {
        return {};
      },
    },

    response: {
      type: Object,
      default() {
        return {};
      },
    },

    loadingTable: {
      type: Boolean,
      default: false,
    },

    loadingRegister: {
      type: Boolean,
      default: false,
    },

    loadingEditAll: {
      type: Boolean,
      default: false,
    },

    filterBadge: {
      type: [Number, String],
      default: 0,
    },
  },

  data() {
    return {
      formData: {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null,
      },
      items: [],
      fields: [],
      checkAll: [],
      checkItem: [],
      showPopoverCheckAll: false,
      showFilter: false,
      lstPages: [
        5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600,
        700, 800, 900,
      ],
    };
  },

  beforeDestroy() {
    this.handlerClear();
  },
  mounted() {
    this.inicialize();
  },

  watch: {
    tableHead() {
      this.handleFields();
    },

    tableData() {
      this.handleItens();
    },

    tableFooter() {},

    onEdit() {},

    onEditAll() {},

    onSearch() {},

    onRegister() {},

    filterBadge() {},

    loadingTable() {},

    loadingEditAll() {},

    loadingRegister() {},

    disabledConfigCell() {
      this.handleFields();
    },

    "response.status"() {},

    config() {},

    device() {
      this.handleFields();
    },

    inputSearch() {
      this.formData.search = this.inputSearch;
    },

    inputFilter() {
      this.formData.filter = this.inputFilter;
    },

    pagination() {
      if (this.pagination && this.pagination.per_page) {
        this.formData.ppage = parseInt(this.pagination.per_page);
      } else {
        this.formData.ppage = 50;
      }
    },
  },

  methods: {
    getUrlFuncionario(_data) {
      let url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url =
          "https://" +
          process.env.URL_API.empresa +
          "/" +
          this.$root.$session.cliente.tenant +
          "/funcionarios/editar/" +
          (_data.funcionario ? _data.funcionario.id : _data.id);
      } else {
        url =
          this.env.url_cs +
          "/app/funcionarios_info.php?abre=" +
          (_data.funcionario ? _data.funcionario.id : _data.id);
      }
      return url;
    },

    getUrlEmpresa(_data) {
      let url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url =
          "https://" +
          process.env.URL_API.empresa +
          "/" +
          this.$root.$session.cliente.tenant +
          "/meu-cadastro?";
      } else {
        url =
          this.env.url_cs +
          "/app/empresas_info.php?abre=" +
          (_data.empresa ? _data.empresa.id : _data.empresa_id);
      }
      return url;
    },

    getUrlConsulta(_data) {
      let url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url = "#";
      } else {
        url = this.env.url_cs + "/app/consulta.php?con=" + _data.id_con;
      }
      return url;
    },

    getUrlLote(_data) {
      let url = "";

      if (this.$root.$session.sub_domain == "empresa") {
        url =
          "https://" +
          process.env.URL_API.empresa +
          "/" +
          this.$root.$session.cliente.tenant +
          "/esocial/gerar-lote" +
          (_data.lote ? "/" + _data.lote : "");
      } else {
        url =
          "https://" +
          process.env.URL_API.web +
          "/esocial/lotes" +
          (_data.lote ? "/" + _data.lote : "");
      }

      return url;
    },

    inicialize() {
      this.formData.search = this.inputSearch;
      this.formData.filter = this.inputFilter;
      this.handleItens();
      this.handleFields();
    },

    handleItens() {
      this.items = this.tableData;
      this.checkItem = [];
      this.checkAll = [];
      this.showPopoverCheckAll = false;
    },

    handlerClear() {
      this.error = {};
      (this.items = []), (this.fields = []);
      this.checkAll = [];
      this.checkItem = [];
      this.formData = {
        search: null,
        sortBy: null,
        sortDesc: false,
        page: 1,
        ppage: 50,
        filter: null,
      };
    },


    handleClear(){
      if(this.onClear){
        this.onClear()
        this.showFilter = !this.showFilter
      }
    },

    handleFields() {
      var fields = [];

      if (this.device != "xs" && !this.disableCheckAll) {
        fields.push({
          key: "selected",
          sortable: true,
          width: "50px",
          label: "",
        });
      }

      for (let i = 0; i < this.tableHead.length; i++) {
        fields.push(this.tableHead[i]);
      }

      if (!this.disabledConfigCell) {
        fields.push({
          key: "buttons",
          class: "table-v2-buttons",
          label: "",
        });
      }

      this.fields = fields;
    },

    handleSearch() {
      this.showPopoverCheckAll = false;
      this.checkAll = [];
      this.checkItem = [];

      if (this.onSearch)
        this.onSearch(
          this.formData.search,
          1,
          this.formData.ppage,
          this.formData.filter
        );
    },

    handleEdit(data) {
      if (this.onEdit) this.onEdit(data);
    },

    handleEditAll() {
      var data = [];

      for (let i = 0; i < this.tableData.length; i++) {
        const element = this.tableData[i];

        if (
          element._data &&
          element._data.id &&
          this.checkItem.indexOf(element._data.id) != -1
        ) {
          data.push(element._data);
        }
      }

      if (this.onEditAll) this.onEditAll(data);
    },

    handleDelete(data) {
      var ids = [];

      if (data && data.id) ids = [data.id];
      else ids = this.checkItem;

      if (ids.length > 0 && this.onDelete) this.onDelete(ids);
    },

    handleFilter: function () {
      this.showFilter = !this.showFilter;
      if (this.onFilter) {
        this.onFilter(
          this.formData.search,
          1,
          this.formData.ppage,
          this.formData.filter
        );
      }
    },

    handleSelectAll: function (check) {
      this.checkItem = [];
      this.showPopoverCheckAll = false;

      if (!check) return;

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];

        if (item && item._data) {
          this.checkItem.push(item._data.id);
        }
      }

      this.showPopoverCheckAll = true;
    },

    handleSelectItem() {
      this.showPopoverCheckAll = this.checkItem.length > 0;
    },

    handleNavigate(page) {
      this.formData.page = page;

      if (this.onSearch)
        this.onSearch(
          this.formData.search,
          this.formData.page,
          this.formData.ppage
        );
    },
  },
};
</script>

<style scopped>
.table-v2 tr th,
.table-v2 tfoot tr td {
  background: var(--primary) !important;
  color: #fff !important;
  vertical-align: middle !important;
  font-size: 13px !important;
  padding: 5px !important;
  text-transform: uppercase;
  font-weight: bold;
}

.table-v2 tr td {
  vertical-align: middle !important;
  font-size: 11px !important;
  padding: 5px !important;
}

.table-v2 .el-checkbox__label {
  display: none !important;
}
.table-v2 tbody tr .config-col button {
  margin-bottom: 5px !important;
}

.table-v2-buttons {
  text-align: center;
  width: 180px;
}

.table-v2 .deleted {
  color: red !important;
}

.table-v2 .el-collapse-item__header {
  background-color: transparent !important;
  border-bottom: none !important;
  line-height: 0 !important;
}

.table-v2 .el-collapse {
  border-top: none !important;
  border-bottom: none !important;
}

.table-v2 .el-collapser {
  border-top: none !important;
  border-bottom: none !important;
}

.table-v2 .el-collapse-item__wrap {
  background-color: transparent !important;
  border: none !important;
}

.el-button + .el-button {
  margin-left: 0 !important;
}

.el-image-viewer__wrapper {
  z-index: 9999999999999999 !important;
}

@media only screen and (max-width: 800px) {
  .table-v2-buttons {
    text-align: center;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// table.vue?68a77fbe